var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49087 7.71065C7.88285 8.31867 6.89705 8.31867 6.28902 7.71065C5.681 7.10262 5.681 6.11681 6.28902 5.50879L7.66518 4.13263C8.24553 3.55227 9.17005 3.52586 9.78173 4.05338M9.59181 2.20602C10.1998 1.59799 11.1856 1.59799 11.7937 2.20602C12.4017 2.81405 12.4017 3.79985 11.7937 4.40788L10.4175 5.78404C9.83716 6.36439 8.91263 6.39081 8.30096 5.86328",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 7.58333C12.25 9.78322 12.25 10.8832 11.5666 11.5666C10.8832 12.25 9.78322 12.25 7.58333 12.25H6.41667C4.21678 12.25 3.11684 12.25 2.43342 11.5666C1.75 10.8832 1.75 9.78322 1.75 7.58333V6.41667C1.75 4.21678 1.75 3.11684 2.43342 2.43342C3.11684 1.75 4.21678 1.75 6.41667 1.75",
    stroke: "#141B34",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLink);
export default __webpack_public_path__ + "static/media/copy-link.230ac5f3589a714cccc852389476c0be.svg";
export { ForwardRef as ReactComponent };